/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_WsInputs */

const en_st_mock_ws = /** @type {(inputs: St_Mock_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio Nusantara`)
};

const id_st_mock_ws = /** @type {(inputs: St_Mock_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio Nusantara`)
};

/**
* | output |
* | --- |
* | "Studio Nusantara" |
*
* @param {St_Mock_WsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_ws = /** @type {((inputs?: St_Mock_WsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_WsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_ws(inputs)
	return en_st_mock_ws(inputs)
});